import { Analytics, getAnalytics, logEvent, isSupported } from "firebase/analytics"
import { getApp } from "firebase/app"
import { config } from "~/config"

let analytics: Analytics | null = null

export async function initializeAnalytics(): Promise<Analytics | null> {
  if (analytics) {
    return analytics
  }

  if (config.env === "local") {
    return null
  }

  const supported = await isSupported()
  if (!supported) {
    return null
  }

  const app = getApp()
  analytics = getAnalytics(app)
  return analytics
}

export function getAnalyticsInstance(): Analytics | null {
  return analytics
}

export function trackPageView(pagePath: string, pageTitle?: string): void {
  if (!analytics) {
    return
  }

  logEvent(analytics, "page_view", {
    page_path: pagePath,
    page_title: pageTitle,
  })
}

export function trackOutboundLink(url: string, linkText?: string): void {
  if (!analytics) {
    return
  }

  logEvent(analytics, "click", {
    link_url: url,
    link_text: linkText,
    outbound: true,
  })
}

export function trackLogin(method?: string): void {
  if (!analytics) {
    return
  }

  logEvent(analytics, "login", {
    method: method,
  })
}

export function trackSignUp(method?: string): void {
  if (!analytics) {
    return
  }

  logEvent(analytics, "sign_up", {
    method: method,
  })
}

export function trackShare(contentType: string, itemId?: string, method?: string): void {
  if (!analytics) {
    return
  }

  logEvent(analytics, "share", {
    content_type: contentType,
    item_id: itemId,
    method: method,
  })
}

export function trackSearch(searchTerm: string): void {
  if (!analytics) {
    return
  }

  logEvent(analytics, "search", {
    search_term: searchTerm,
  })
}

export function trackSelectContent(contentType: string, itemId?: string): void {
  if (!analytics) {
    return
  }

  logEvent(analytics, "select_content", {
    content_type: contentType,
    item_id: itemId,
  })
}

export function trackViewItem(itemId: string, itemName?: string, itemCategory?: string): void {
  if (!analytics) {
    return
  }

  logEvent(analytics, "view_item", {
    items: [{
      item_id: itemId,
      item_name: itemName,
      item_category: itemCategory,
    }],
  })
}
